import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import { useRef, useState } from "react";
import MainInfo from "../components/layout-sections/MainInfo.tsx";
import { theme } from "../theme.ts";
import PdfAppBar from "../components/PdfAppBar.tsx";
import Footer from "../components/layout-sections/Footer.tsx";
import RequestAccess from "../components/layout-sections/RequestAccess.tsx";
import ChaosToClarity from "../components/layout-sections/ChaosToClarity.tsx";
import DataPrivate from "../components/layout-sections/DataPrivate.tsx";
import FeaturesGrid from "../components/layout-sections/FeaturesGrid.tsx";
import PrivacyFirst from "../components/layout-sections/PrivacyFirst.tsx";
import ReasoningEngine from "../components/layout-sections/ReasoningEngine.tsx";
import SmartCapabilities from "../components/layout-sections/SmartCapabilities.tsx";
import Terms from "../components/layout-sections/Terms.tsx";
import { Helmet } from "react-helmet";

function Layout() {
  const lessThanXL = useMediaQuery(theme.breakpoints.down("md"));
  const [showTerms, setShowTerms] = useState(false);

  const endRef = useRef<null | HTMLDivElement>(null);
  const aboutRef = useRef<null | HTMLDivElement>(null);

  const scrollToBottom = () => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToAbout = () => {
    aboutRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToTopAndShowTerms = () => {
    setShowTerms(true);
    window.scrollTo(0, 0);
  };

  const scrollToTopAndShowMainPage = () => {
    setShowTerms(false);
    window.scrollTo(0, 0);
  };

  const scrollToAboutAndShowMainPage = () => {
    setShowTerms(false);
    setTimeout(() => {
      scrollToAbout();
    });
  };
  return (
    <>
      <Helmet>
        <title>Get Insights from Documents | DokuSense AI</title>
        <meta
          name="description"
          content="Use AI to extract insights from your documents. Chat, summarize, and manage them efficiently on a single platform."
        />
        <meta property="og:title" content="DokuSense AI – AI for Documents" />
        <meta
          property="og:description"
          content="Seamlessly engage with your documents using AI. Summarize, chat, and organize your files all in one place."
        />
        <meta property="og:image" content="/preview.jpg" />
      </Helmet>

      <PdfAppBar
        scrollToAbout={scrollToAbout}
        scrollToAboutAndShowMainPage={scrollToAboutAndShowMainPage}
        showTerms={showTerms}
        lessThanXL={lessThanXL}
        mobileOpen={null}
        scrollToBottom={scrollToBottom}
        scrollToTopAndShowMainPage={scrollToTopAndShowMainPage}
      />
      <Box>
        {!showTerms ? (
          <>
            <MainInfo lessThanXL={lessThanXL} scrollToBottom={scrollToBottom} />
            <Box
              mt={3}
              sx={{
                background:
                  "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
                width: "auto",
                height: "1px",
              }}
            ></Box>
            <ChaosToClarity lessThanXL={lessThanXL} />

            <div ref={aboutRef} />
            <Box
              mt={13}
              sx={{
                background:
                  "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
                width: "auto",
                height: "1px",
              }}
            ></Box>
            <DataPrivate
              lessThanXL={lessThanXL}
              scrollToBottom={scrollToBottom}
            />
            <Box
              sx={{
                background:
                  "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
                width: "auto",
                height: "1px",
              }}
            ></Box>
            <FeaturesGrid
              lessThanXL={lessThanXL}
              scrollToBottom={scrollToBottom}
            />
            <Box
              mt={15}
              sx={{
                background:
                  "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
                width: "auto",
                height: "1px",
              }}
            ></Box>
            <PrivacyFirst lessThanXL={lessThanXL} />
            <Box
              mt={15}
              sx={{
                background:
                  "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
                width: "auto",
                height: "1px",
              }}
            ></Box>
            <ReasoningEngine
              lessThanXL={lessThanXL}
              scrollToBottom={scrollToBottom}
            />
            <Box
              sx={{
                background:
                  "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
                width: "auto",
                height: "1px",
              }}
            ></Box>
            <SmartCapabilities lessThanXL={lessThanXL} />
            <Box
              mt={10}
              sx={{
                background:
                  "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
                width: "auto",
                height: "1px",
              }}
            ></Box>
            <div ref={endRef} />
            <RequestAccess lessThanXL={lessThanXL} />
          </>
        ) : (
          ""
        )}
        {showTerms ? (
          <>
            <Terms lessThanXL={lessThanXL} />
          </>
        ) : (
          ""
        )}
        <Box
          mt={22}
          sx={{
            background:
              "linear-gradient(90deg, #D0D0D0 0%, #E0E0E0 50%, #D0D0D0 100%)",
            width: "auto",
            height: "1px",
          }}
        ></Box>

        <Footer
          scrollToTopAndShowTerms={scrollToTopAndShowTerms}
          lessThanXL={lessThanXL}
        />
      </Box>
    </>
  );
}

export default Layout;
